export default __webpack_public_path__ + "static/media/12.4fcd3c45.JPG";